import React from "react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

const Breadcrumb = ({ items = [], separator, maxLabelLength = 20 }) => {
  if (!items.length) return null;

  const truncateLabel = (label) => {
    if (!label) return "";
    return label.length > maxLabelLength ? `${label.slice(0, maxLabelLength)}…` : label;
  };

  return (
    <nav
      className="flex items-center text-gray-600"
      aria-label="breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const Icon = item.icon;

        const content = (
          <span
            title={item.label.length > maxLabelLength ? item.label : undefined}
            className={`flex items-center gap-1.5 ${item.active || isLast ? "font-medium text-highlightColor" : "text-gray-600"}`}>
            {Icon && <Icon className="h-4 w-4" />}
            {truncateLabel(item.label)}
          </span>
        );

        return (
          <React.Fragment key={index}>
            {item.onClick && !isLast ? (
              <button
                onClick={item.onClick}
                className="flex items-center transition hover:text-highlightColor hover:underline">
                {content}
              </button>
            ) : (
              content
            )}

            {!isLast && (separator || <ChevronRightIcon className="mx-1 h-5 w-5 text-gray-400" />)}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
